$(document).ready(function(){
    jQuery('.scrollTo').click(function(e) {
        let jump = jQuery(this).attr('href');
        let new_position = jQuery(jump).offset();
        let scroll = 10;
        jQuery('html, body').stop().animate({ scrollTop: new_position.top + scroll }, 800, function(){
            let new_position = jQuery(jump).offset();
            jQuery('html, body').stop().animate({ scrollTop: new_position.top + scroll }, 800);
        });
        e.preventDefault();
    });
    // helper function
    function manageMobileSliders(...sliders) {
        sliders.forEach(initFn => {
            if (window.innerWidth <= 991) {
                initFn();
            }
            window.addEventListener('resize', function () {
                if (window.innerWidth <= 991) {
                    initFn();
                } else {
                    initFn(true);
                }
            });
        });
    }
    function hideMobileSliders(...sliders) {
        sliders.forEach(initFn => {
            if (window.innerWidth > 991) {
                initFn();
            }
            window.addEventListener('resize', function () {
                if (window.innerWidth > 991) {
                    initFn();
                } else {
                    initFn(true);
                }
            });
        });
    }

    // Menu open/close + submenu handling moved to assets/cw-a11y.js (keyboard + screen-reader support).

    // Menu open close Script End Here

    // USPA Slider Start Here
    if($('.js-uspa-slider').length > 0){
        $('.js-uspa-slider').slick({
            speed: 4000,
            autoplay: true,
            autoplaySpeed: 0,
            cssEase: "linear",
            slidesToShow: 4,
            slidesToScroll: 1,
            variableWidth: true,
            infinite: true,
            arrows: false,
            dots: false,
            draggable: false,
            pauseOnHover: false,
            swipeToSlide: false,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                    slidesToShow: 3,
                    infinite:true,
                    }
                }
                ,
                {
                    breakpoint: 767,
                    settings: {
                    slidesToShow: 2,
                    infinite:true,
                    }
                }
            ]
        });
    }
    // USPA Slider Start Here



    if($('.js-new-uspa-slider').length > 0){
        $('.js-new-uspa-slider').slick({
            speed: 10000,
            autoplay: true,
            autoplaySpeed: 0,
            cssEase: "linear",
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            infinite: true,
            arrows: false,
            dots: false,
            draggable: false,
            pauseOnHover: false,
            swipeToSlide: false
        });
    }

     if($('.home-banner-slider').length > 0){
        $('.home-banner-slider').slick({
            autoplay: true,
            speed: 500,
            fade: true,
            cssEase: 'linear',
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            arrows: false,
            dots: false,
            draggable: false,
            pauseOnHover: false,
            swipeToSlide: false
        });
    }
    function initSlider() {
        if ($(window).width() <= 768) {
            if (!$('.reviews-grid').hasClass('slick-initialized')) {
                $('.reviews-grid').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: false,
                    infinite: true,
                    centerMode: true, 
                });
            }
            } else {
            if ($('.reviews-grid').hasClass('slick-initialized')) {
                $('.reviews-grid').slick('unslick');
            }
        }
    }

    initSlider();
    $(window).on('resize', initSlider); 

    // Customer Review Slider Start Here
    if($('.js-customer-review-slider-main').length > 0){
        $('.js-customer-review-slider-main').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            arrows: true,
            autoplay:false,
            autoplaySpeed:3000,
            centerMode: false,
            adaptiveHeight:false,
            draggable: true,
            asNavFor: '.js-customer-review-slider-nav',
            prevArrow: $('.js-customer-review-slider-prev'),
            nextArrow: $('.js-customer-review-slider-next'),
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }
            ]
        });
    }
    if($('.js-customer-review-slider-nav').length > 0){
        $('.js-customer-review-slider-nav').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            arrows: false,
            fade: true,
            centerMode: false,
            draggable: false,
            asNavFor: '.js-customer-review-slider-main',
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        adaptiveHeight: true
                    }
                }
            ]
        });
    }
    // Customer Review Slider End Here

    // Ketones Community Slider Start Here
    if($('.js-ketones-community-slider').length > 0){
        $('.js-ketones-community-slider').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            arrows: true,
            dots: false,
            variableWidth: true,
            centerMode: false,
            asNavFor: '.js-cw-ketones-community-slider-nav',
            prevArrow: $('.js-ketones-community-prev'),
            nextArrow: $('.js-ketones-community-next'),
            responsive: [
               {
                  breakpoint: 992,
                  settings: {
                     slidesToShow: 2,
                  }
               },
               {
                  breakpoint: 768,
                  settings: {
                     slidesToShow: 1,
                     variableWidth: false
                  }
               },
            ]
        });
        $('.js-ketones-community-slider.slick-initialized .slick-slide.slick-current').addClass('slick-custom-active');        
        setTimeout(function() {
            $('.js-ketones-community-slider').on('afterChange', function(event, slick, currentSlide) {
                $(".slick-slide").removeClass('slick-custom-active');
                $('.slick-current').addClass('slick-custom-active');
            });
        }, 100);
        $(document).on('click', '.js-ketones-community-slider .slick-slide', function(){
            $('.js-ketones-community-slider .slick-slide').removeClass('slick-custom-active');
            $(this).addClass('slick-custom-active');
        });
    }
    if($('.js-cw-ketones-community-slider-nav').length > 0){
        $('.js-cw-ketones-community-slider-nav').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            arrows: false,
            fade: true,
            centerMode: false,
            asNavFor: '.js-ketones-community-slider',
        });
    }
    // Ketones Community Slider Start Here

    // Ketones Community Slider v1 Start Here
    if($('.js-ketones-community-slider-v1').length > 0){
        $('.js-ketones-community-slider-v1').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 1,
            infinite: false,
            arrows: true,
            centerMode: false,
            variableWidth: false,
            pauseOnHover: false,
            pauseOnFocus: false,
            asNavFor: '.js-cw-ketones-community-slider-nav-v1',
            prevArrow: $('.js-ketones-community-v1-prev'),
            nextArrow: $('.js-ketones-community-v1-next'),
            responsive: [
               {
                  breakpoint: 992,
                  settings: {
                     slidesToShow: 2,
                  }
               },
               {
                  breakpoint: 768,
                  settings: {
                     slidesToShow: 1,
                     variableWidth: false
                  }
               },
            ]
        });      
    }
    if($('.js-cw-ketones-community-slider-nav-v1').length > 0){
        $('.js-cw-ketones-community-slider-nav-v1').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 1,
            infinite: false,
            arrows: false,
            fade: true,
            centerMode: false,
            asNavFor: '.js-ketones-community-slider-v1',
        });
    }
    // Ketones Community Slider v1 Start Here

    // product-details slider start here
    if($('.js-product-details-slider-main').length > 0){
        $('.js-product-details-slider-main').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            focusOnSelect: false,
            infinite: true,
            speed: 500,
            fade: true,
            asNavFor: '.js-product-details-slider-nav'
        });
    }
    if($('.js-product-details-slider-nav').length > 0){
        $('.js-product-details-slider-nav').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: false,
            focusOnSelect: true,
            infinite: true,            
            asNavFor: '.js-product-details-slider-main',
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 4
                    }
                }
            ]
        });
    }
    // product-details slider end here
    
    function tabMatchHeight(){
        if($('.cw-ketones-tastebuds__text-desc').length > 0){
            $('.cw-ketones-tastebuds__text-desc').matchHeight({
                byRow: true,
            });
        }
    }
    tabMatchHeight();
    if($('.cw-ketones-tastebuds__tab-content-wrap .box .box-desc h4').length > 0){
        $('.cw-ketones-tastebuds__tab-content-wrap .box .box-desc h4').matchHeight({
            byRow: true,
        });
        
    }
    if($('.cw-naturally-beneficial-drink__content .info-box-wrap h3').length > 0){
        $('.cw-naturally-beneficial-drink__content .info-box-wrap h3').matchHeight({
            byRow: false,
        });        
    }
    if($('.cw-naturally-beneficial-drink__content .info-box-wrap .desc-text').length > 0){
        $('.cw-naturally-beneficial-drink__content .info-box-wrap .desc-text').matchHeight({
            byRow: false,
        });        
    }
    if($('.cw-how-interfast-works__content .box__desc .cw-text').length > 0){
        $('.cw-how-interfast-works__content .box__desc .cw-text').matchHeight({
            byRow: false,
        });        
    }
    if($('.product__grid__info.text-center .product__grid__title__wrapper').length > 0){
        $('.product__grid__info.text-center .product__grid__title__wrapper').matchHeight({
            byRow: true,
        });        
    }
    if($('.cw-benefits-your-brain__content .box__desc').length > 0){
        $('.cw-benefits-your-brain__content .box__desc').matchHeight({
            byRow: true,
        });        
    }  
    if($('.cw-naturally-beneficial-drink-v1__content .info-box-wrap h3').length > 0){
        $('.cw-naturally-beneficial-drink-v1__content .info-box-wrap h3').matchHeight({
            byRow: false,
        });        
    }  
    if($('.cw-naturally-beneficial-drink-v1__content .info-box-wrap .desc-text').length > 0){
        $('.cw-naturally-beneficial-drink-v1__content .info-box-wrap .desc-text').matchHeight({
            byRow: false,
        });        
    }    
    

    // CW HP Ketones Tastebuds Start here
    $('.js-tab-link').click( function() {
        let tabLink = $(this).attr('data-tab');
        $(this).addClass('active').siblings().removeClass('active');
        $('#cw-ketones-tastebuds-tab-'+tabLink).addClass('active').siblings().removeClass('active');
        tabMatchHeight();
    });
    // CW HP Ketones Tastebuds End here

    // Accordian js Start here
    $(function () {
        $('.js-accordian-title').click(function (j) {
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                $(this).next().slideUp();
            } else{
                $('.js-accordian-title').removeClass('active');
                $('.js-accordian-title').next().slideUp();
                $(this).addClass('active');
                $(this).next().slideDown(function(){
                    $(this).css('display', 'block');
                });
            }
            
        });
    }); 
    

    $(function () {
        // Initial animation for the first card
        $('.cus-accordian-v2__card.active').find('.faq-image-small').css({ width: "0" });
        $('.cus-accordian-v2__card.active').find('.title-text-wrap').css({ "padding-left": "0", "max-width": "100%" });
        $('.cus-accordian-v2__card.active').find('.title-text-wrap h5').css({ "font-size": "32px" });
        $('.cus-accordian-v2__card.active').find('.faq-image-big').css({ "padding-bottom": "50.9%", "margin-bottom": "12px" });
        $('.cus-accordian-v2__card.active .cus-accordian-v2__panel').show();
    
        // Click event for accordion titles
        $('.js-accordian-title-v2').click(function () {
            let $this = $(this);
            let $card = $this.parents('.cus-accordian-v2__card');
    
            if ($card.hasClass('active')) {
                // Collapse the current card
                $card.removeClass('active');
                $this.removeClass('active');
                $this.next('.cus-accordian-v2__panel').slideUp();
                $this.find('.faq-image-small').animate({ width: "100%" }, 'slow');
                $card.find('.title-text-wrap').animate({ "padding-left": "27px", "max-width": "calc(100% - 106px)" }, 'slow');
                $card.find('.title-text-wrap h5').animate({ "font-size": "22px" }, 'slow');
                $card.find('.faq-image-big').animate({ "padding-bottom": "0", "margin-bottom": "0" });
            } else {
                // Collapse all other cards
                $('.cus-accordian-v2__card').removeClass('active').find('.cus-accordian-v2__panel').slideUp();
                $('.js-accordian-title-v2').removeClass('active');
                $('.cus-accordian-v2__card').find('.faq-image-small').animate({ width: "100%" }, 'slow');
                $('.cus-accordian-v2__card').find('.title-text-wrap').animate({ "padding-left": "27px", "max-width": "calc(100% - 106px)" }, 'slow');
                $('.cus-accordian-v2__card').find('.title-text-wrap h5').animate({ "font-size": "22px" }, 'slow');
                $('.cus-accordian-v2__card').find('.faq-image-big').animate({ "padding-bottom": "0", "margin-bottom": "0" });
    
                // Expand the clicked card
                $card.addClass('active');
                $this.addClass('active');
                $this.find('.faq-image-small').animate({ width: "0" }, 'slow');
                $card.find('.title-text-wrap').animate({ "padding-left": "0", "max-width": "100%" }, 'slow');
                $card.find('.title-text-wrap h5').animate({ "font-size": "32px" }, 'slow');
                $card.find('.faq-image-big').animate({ "padding-bottom": "50.9%", "margin-bottom": "12px" });
                $this.next('.cus-accordian-v2__panel').slideDown(function () {
                    $(this).css({'display': 'block'}, 'slow');
                });
            }
        });
    });
    // Accordian js End here

    // Product QTY js start here
    $(document).on('click','.js-button', function () {
        let val = parseInt($(this).parent().find("input").val());
      
        if ($(this).hasClass("less")) {
          val = val - 1;
        } else if ($(this).hasClass("more")) {
          val = val + 1;
        }      
        if (val < 1) {
          val = 1;
        }      
        $(this).parent().find("input").val(val);
    });      
    // Product QTY js end here

    // Subscription Active class js start here
    $('.cw-product-banner__subscription-box-wrap .wn-product__purchase-options input[type=radio]:checked').parents('.wn-product__purchase-options').addClass('active');
    $(document).on('click', '.cw-product-banner__subscription-box-wrap .wn-product__purchase-options input[type=radio]', function(){
        let $parent = $(this).parents('.wn-product__purchase-options');        
        $parent.siblings('.wn-product__purchase-options').removeClass('active');
        $parent.addClass('active');
    });
    // Subscription Active class js end here

    Fancybox.bind("[data-fancybox]");

    // FAQ filter start here
    if ($('.cw-ketones-faq .cw-ketones-faq__filter-head').length > 0) {
        let $firstButton = $('.cw-ketones-faq__filter-head button:first');
        $firstButton.addClass('active');
        filterAccordions($firstButton.attr('data-filter'));
    }

    $('.js-filter-button').on('click', function() {
        let $this = $(this);
        $this.addClass('active').siblings().removeClass('active');
        filterAccordions($this.attr('data-filter'));
    });

    function filterAccordions(dataFilter) {
        if (dataFilter === 'general') {
            $('.cus-accordian__card').removeClass('is-hidden');
        } else {
            $('.cus-accordian__card').addClass('is-hidden')
                .filter(`[data-filter="${dataFilter}"]`).removeClass('is-hidden');
        }

        let firstMatch = $('.cus-accordian__card').filter(`[data-filter="${dataFilter}"]`).first();
        if (firstMatch.length) {
            firstMatch.find('.js-accordian-title').addClass('active');
            firstMatch.find('.cus-accordian__panel').css('display', 'block');
        }
    }    
    // FAQ filter end here

    // side cart js start here
    $(document).on('click', '.js-side-cart', function(){
        $('body').addClass('open-side-cart');
    });
    $(document).on('click', '.js-close-cart', function(){
        $('body').removeClass('open-side-cart');
    });
    $(document).on("click", function(event){
        let $trigger = $(".js-side-cart, .cw-side-cart");
        if($trigger !== event.target && !$trigger.has(event.target).length){
            $('body').removeClass('open-side-cart');
        }
    });
    
    let progress = document.querySelector('.progress-done');
    if(progress){
    progress.style.width = progress.getAttribute('data-done') + '%';
    progress.style.opacity = 1;
    }
    // side cart js start here


function updateVariantSelection() {
   $(document).on('change', '.select-box select[name="variant-choose"]', function () {
    let $card = $(this).closest('.product-card');  // scope to the product card
    let allSelectedValues = [];

    $card.find('.select-box select[name="variant-choose"]').each(function () {
        let selectedValue = $(this).val();
        if (selectedValue) {
            allSelectedValues.push(selectedValue);
        }
    });

    let combinedValues = allSelectedValues.join(' / ');

    $card.find('.variant-select option').each(function () {
        if ($(this).val() === combinedValues) {

            $(this).prop('selected', true).trigger('change');

            let selected_id = $(this).data('id');
            let selected_price = $(this).data('price');

            $card.find('.atc-button').attr('data-id', selected_id);
            $card.find('.price').text(selected_price);

            return false; // stop loop once matched
        }
    });
});

}
updateVariantSelection();
$(document).on('click', '.product-cta .atc-button', function(e) {
    e.preventDefault();

    let $button = $(this);
    let variantId = $button.attr('data-id');

    if (!variantId) return;

    let formData = {
      items: [
        {
          id: variantId,
          quantity: 1
        }
      ]
    };

    // Disable button while adding
    $button.prop('disabled', true).text('Adding...');

    // AJAX request to Shopify cart
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: JSON.stringify(formData),
      dataType: 'json',
      contentType: 'application/json',
      success: function(response) {
       $('.js-side-cart').trigger('click');
        // Re-enable button
        $button.prop('disabled', false).text('Add to Cart');
      },
      })
    })
});